import { Controller } from "@hotwired/stimulus"

// Adds +/- buttons around a quantity input while keeping the field editable.
export default class extends Controller {
  static targets = ["input"]
  static values = {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 20 }
  }

  decrement() {
    this.setValue(this.current - 1)
  }

  increment() {
    this.setValue(this.current + 1)
  }

  get current() {
    const parsed = parseInt(this.inputTarget.value, 10)
    return Number.isNaN(parsed) ? this.minValue : parsed
  }

  setValue(value) {
    const clamped = Math.min(this.maxValue, Math.max(this.minValue, value))
    this.inputTarget.value = clamped
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
